import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import walletApi from '../../lib/walletApi';
import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { GraduationCap, Users, ChevronRight, Loader2, Building2 } from 'lucide-react';

export default function StudentAccountsLanding() {
  const navigate = useNavigate();
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const data = await walletApi.get('/super-admin/companies').then(r => r.data);
        setCompanies(Array.isArray(data) ? data : []);
      } catch {}
      finally { setLoading(false); }
    };
    load();
  }, []);

  if (loading) return <div className="flex justify-center py-20"><Loader2 className="w-6 h-6 animate-spin text-pink-400" /></div>;

  return (
    <div className="space-y-5" data-testid="student-accounts-landing">
      <div>
        <h1 className="text-xl font-bold text-gray-900">Employee Accounts</h1>
        <p className="text-sm text-gray-500 mt-0.5">Select a company to manage student virtual accounts</p>
      </div>
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {companies.map(c => (
          <Card key={c.id} className="border-gray-200 hover:border-pink-200 hover:shadow-md transition cursor-pointer group"
            onClick={() => navigate(`/super-admin/companies/${c.id}/students`)} data-testid={`company-card-${c.id}`}>
            <CardContent className="p-4">
              <div className="flex items-start justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-lg bg-pink-50 flex items-center justify-center">
                    <Building2 className="w-5 h-5 text-pink-500" />
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900 text-sm">{c.name}</p>
                    <p className="text-xs text-gray-400 mt-0.5">{c.status}</p>
                  </div>
                </div>
                <ChevronRight className="w-4 h-4 text-gray-300 group-hover:text-pink-400 transition mt-1" />
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
      {companies.length === 0 && (
        <p className="text-sm text-gray-400 text-center py-8">No companies found</p>
      )}
    </div>
  );
}
